import { ObjetKStatusCode } from '@siclop/kstone-vue'

export class ServiceType extends ObjetKStatusCode {
  color: string = '#27ae60'
  defaultHourlyRate: number = 0
  description: string = ''

  constructor(data?: Partial<ServiceType>) {
    super(data)
    if (data) {
      this.color = data.color ?? '#27ae60'
      this.defaultHourlyRate = data.defaultHourlyRate ?? 0
      this.description = data.description ?? ''
    }
  }
}
